<mat-dialog-content>
  <form [formGroup]="customerForm">
    <h3>
      <strong>{{ 'Modify Client' | translate }}</strong>
    </h3>
    <div class="row">
      <span>{{ 'Customer Type' | translate }}:</span>
      <select
        class="form-control"
        formControlName="cust_type"
        [compareWith]="compareCustomerType"
      >
        <option selected value="">
          {{ 'Select customer type' | translate }}
        </option>
        @for (types of customerTypeList; track types) {
          <option [ngValue]="types" [disabled]="types.type === 'Prospecto'">
            {{ types.type }}
          </option>
        }
      </select>
      @if (textValid('cust_type')) {
        <span class="form-text text-danger">{{
          'You must select a type' | translate
        }}</span>
      }
    </div>
    <div class="row">
      <div class="col-md-4">
        <span>{{ 'Document Type' | translate }}:</span>
        <select
          class="form-control"
          formControlName="types_docs"
          [compareWith]="compareDocType"
          (change)="updateSelectedType()"
        >
          <option selected value="">{{ 'Select Type' | translate }}</option>
          @for (types of documenTypeList; track types) {
            <option [ngValue]="types">
              {{ types.description }}
            </option>
          }
        </select>
        @if (textValid('types_docs')) {
          <span class="form-text text-danger">{{
            'You must select a type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-3">
        <span> {{ 'Document Or Nit' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="doc_nit"
        />
        @if (textValid('doc_nit')) {
          <span class="form-text text-danger">{{
            'The document must be wrote' | translate
          }}</span>
        }
      </div>
      <div class="col-md-1">
        <span> {{ 'DV' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="dv"
        />
        @if (textValid('dv')) {
          <span class="form-text text-danger">{{
            'The verification digit must be only 1 numbers' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Company Name' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="name"
        />
        @if (textValid('name')) {
          <span class="form-text text-danger">{{
            'The name must be wrote' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Company Phone' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="phone"
        />
        @if (textValid('phone')) {
          <span class="form-text text-danger">{{
            'The phone must be only numbers' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Company Email' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="email"
        />
        @if (textValid('email')) {
          <span class="form-text text-danger">{{
            'The email is not a valid' | translate
          }}</span>
        }
      </div>
      @if (companyId === '9') {
        <div class="col-md-4">
          <label for="exampleFormControlFile1">RUT (PDF)</label>
          <input
            (change)="getFile($event)"
            type="file"
            class="form-control-file"
            formControlName="RUT"
          />
          @if (textValid('RUT')) {
            <span class="form-text text-danger">{{
              'You must enter the RUT in PDF' | translate
            }}</span>
          }
        </div>
      }
      <div class="col-md-4">
        <span> {{ 'Company Country' | translate }}:</span>
        <select
          (change)="setCity(false)"
          class="form-control"
          formControlName="country"
          [compareWith]="compareCountry"
        >
          <option selected value="">{{ 'Select Country' | translate }}</option>
          @for (country of countryList; track country) {
            <option [ngValue]="country">{{ country.name }}</option>
          }
        </select>
        @if (textValid('country')) {
          <span class="form-text text-danger">{{
            'The country is not valid' | translate
          }}</span>
        }
      </div>
      @if (this.customerForm.value.country.name === 'Colombia') {
        <div class="col-md-4">
          <span> {{ 'Select city' | translate }} </span>
          @if (usesBilly) {
            <select
              (change)="getCitySelect()"
              class="form-control"
              formControlName="citySelect"
              [compareWith]="compareCityBilly"
            >
              <option selected value="">
                {{ 'Select city' | translate }}
              </option>
              @if (customerForm.value.citySelect?.attributes) {
                <option [ngValue]="customerForm.value.citySelect">
                  {{ customerForm.value.citySelect?.attributes.name }}
                </option>
              }
              @for (cities of billyCities.data; track cities) {
                <option [ngValue]="cities">
                  {{ cities.attributes.name }}
                </option>
              }
            </select>
          } @else {
            <select
              (change)="getCitySelect()"
              class="form-control"
              formControlName="citySelect"
              [compareWith]="compareCityInternal"
            >
              <option selected value="">
                {{ 'Select city' | translate }}
              </option>
              @if (customerForm.value.citySelect?.name) {
                <option [ngValue]="customerForm.value.citySelect">
                  {{ customerForm.value.citySelect?.name }}
                </option>
              }
              @for (city of ownCities; track city) {
                <option [ngValue]="city">{{ city.name }}</option>
              }
            </select>
          }
          @if (textValid('city')) {
            <span class="form-text text-danger">{{
              'The city is not valid' | translate
            }}</span>
          }
        </div>
      }
      @if (this.customerForm.value.country.name !== 'Colombia') {
        <div class="col-md-4">
          <span> {{ 'City' | translate }}:</span>
          <input
            class="form-control"
            [matAutocomplete]="autocompleteCity"
            placeholder="{{ 'Select city' | translate }}"
            formControlName="citySelect"
          />
          <mat-autocomplete
            (optionSelected)="getCitySelect()"
            #autocompleteCity="matAutocomplete"
            [displayWith]="displayFnCity"
          >
            @for (city of filterCities$ | async; track city) {
              <mat-option [value]="city">
                {{ city }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (textValid('city')) {
            <span class="form-text text-danger">{{
              'The city is not valid' | translate
            }}</span>
          }
        </div>
      }
      <div class="col-md-4">
        <span>{{ 'Seller' | translate }}:</span>
        <select
          class="form-control"
          formControlName="seller"
          [compareWith]="compareSeller"
        >
          <option selected value="">{{ 'Select Seller' | translate }}</option>
          @for (seller of sellerLists; track seller) {
            <option [ngValue]="seller">
              {{ seller.seller.nombre }}
            </option>
          }
        </select>
        @if (textValid('seller')) {
          <span class="form-text text-danger">{{
            'You must select a seller' | translate
          }}</span>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <span> {{ 'Company Address' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="address"
        />
        @if (textValid('address')) {
          <span class="form-text text-danger">{{
            'The address must be wrote' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Location' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'N/A' | translate }}"
          formControlName="coordinates"
        />
        @if (textValid('coordinates')) {
          <span class="form-text text-danger">{{
            'Location invalid' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Select Location' | translate }}:</span> &nbsp; <br />
        <button (click)="openDialog()" mat-raised-button>
          {{ 'Select Location' | translate }}
        </button>
      </div>
      <div class="col-md-4">
        <span>{{ 'Contributor Type' | translate }}:</span>
        <select
          class="form-control"
          formControlName="contributorType"
          [compareWith]="compareContributor"
        >
          <option selected value="">
            {{ 'Select Contributor Type' | translate }}
          </option>
          @for (contributor of contributorTypeList; track contributor) {
            <option [ngValue]="contributor">
              {{ contributor.description }}
            </option>
          }
        </select>
        @if (textValid('contributorType')) {
          <span class="form-text text-danger">{{
            'You must select a contributor type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span>{{ 'Segment' | translate }}:</span>
        <select
          class="form-control"
          formControlName="segment"
          [compareWith]="compareSegment"
        >
          <option selected value="">{{ 'Select Segment' | translate }}</option>
          @for (segment of customerSegmentList; track segment) {
            <option [ngValue]="segment">
              {{ segment.nombre }}
            </option>
          }
        </select>
        @if (textValid('segment')) {
          <span class="form-text text-danger">{{
            'You must select a segment' | translate
          }}</span>
        }
      </div>
    </div>
  </form>
  <div>
    <span class="form-text text-danger ml-2">{{
      clientErrorMessage | translate
    }}</span>
    <div
      class="d-flex flex-column flex-md-row align-items-center justify-content-start"
      id="buttons-div"
    >
      <div id="buttons">
        <button (click)="validUpdate()" mat-raised-button>
          {{ 'Modify' | translate }}
        </button>
      </div>
      <div class="central-button">
        <button
          matTooltip="{{
            'VERIFICAR HABILITACION PARA FACTURACION ELECTRONICA' | translate
          }}"
          matTooltipPosition="above"
          [disabled]="!useElectronicBilling || !wasCreated"
          (click)="verifyPayerSent()"
          mat-raised-button
        >
          {{ 'EI Verify' | translate }}
        </button>
      </div>
      <div id="buttons">
        <button mat-raised-button [mat-dialog-close]="false">
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p style="font-size: 20px; color: #ffffff">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
